import angular from 'angular';
import uiRouter from 'angular-ui-router';
import faqComponent from './faq.component';
import faqListComponent from './faq-list.component';
import faqCategoryListComponent from '../categories-faq/categories-list.component';
import faqService from './faq.service';
import logListComponent from './log-list.component';
import logDetailListComponent from './log-detail-list.component';
import FaqCategoryService from '../categories-faq/categories.service';

let faqModule = angular.module('appfaq', [
  uiRouter
])
.service('Faq', faqService)
.service('Categorie', FaqCategoryService)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/faq');

  $stateProvider
    .state('faq', {
      component: 'faq'
    })
    .state('faq.list', {
      url: '/faq',
      component: 'faqList'
    })
    .state('faq.categories.list', {
      url: '/faq/categories',
      component: 'faqCategoryList'
    })
    .state('faq.log-list', {
      url: '/faq/log',
      component: 'logList'
    })
    .state('faq.log-detail', {
      url: '/faq/log/:id',
      component: 'logDetailList',
      params: {
        id: ""
      }
    })
})
.component('faq', faqComponent)
.component('faqList', faqListComponent)
.component('faqCategoryList', faqCategoryListComponent)
.component('logList', logListComponent)
.component('logDetailList', logDetailListComponent)
.name;

export default faqModule;



// WEBPACK FOOTER //
// ./client/app/components/faq/faq.js